/* eslint-disable no-param-reassign */
import axios, {
  AxiosError, AxiosRequestConfig, AxiosResponse,
} from 'axios';
import LocalStorageService from '@/services/LocalStorageService';
import NotificationService from '@/services/NotificationService';
// import { MutationTypes, useStore } from '@/store';
// import { IUser, IUserInfo } from '@/types/interfaces';
// eslint-disable-next-line import/no-cycle
import router from '@/router';

const http = axios.create({
  baseURL: process.env.VUE_APP_MONITORING_URL,
  headers: {
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json',
  },
});

http.interceptors.request.use((request: AxiosRequestConfig) => {
  request.headers!.authToken = LocalStorageService.getAuthToken();
  request.headers!.language = LocalStorageService.getLanguage();
  request.headers!.sourceLocation = router.currentRoute.value.meta?.navigationPage || '';
  // request.headers['UTC-timezone'] = new Date().getTimezoneOffset() / 60;
  return request;
}, (error: AxiosError) => Promise.reject(error));

http.interceptors.response.use((response: AxiosResponse<{ success: boolean; errorKey: string; message: string }>) => {
  if (['put', 'delete', 'PUT', 'DELETE'].includes(String(response.config.method)) && response.data.success) {
    NotificationService.notifySuccess();
  }
  return response;
});

export default http;
